<template>
  <div class="combWrap">
    <el-select
      v-model="localValue"
      placeholder="请选择"
      :style="selectStyle"
      v-bind="$attrs"
      @change="val => $emit('change', val)"
    >
        <el-option
            v-for="item in items"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        >
        </el-option>
    </el-select>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'search-select-comb',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: [String, Number],
    items: {
      type: Array,
      default: () => []
    },
    selectStyle:{
      type: String,
      default: ''
    },
    attrs: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      localValue: this.value
    }
  },
  watch: {
    value(val) {
      this.localValue = val
    },
    localValue(val) {
      this.$emit('change', val)
    }
  },
  computed: {},
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.combWrap {
  display: inline-block;
  ::v-deep .el-select{
    .el-input input.el-input__inner{
      border-right: none;
    }
  }
}
</style>